import { styled } from '@mui/material'
import { colorPalette } from '../../../../style/colorPalette'

export const HeaderIconButton = styled('button')({
  border: `1px solid ${colorPalette.monotone[2]}`,
  borderRadius: '4px',
  backgroundColor: colorPalette.monotone[0],
  width: '24px',
  height: '24px',
  padding: 0,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  cursor: 'pointer',
  '&:disabled': {
    cursor: 'not-allowed',
    opacity: 0.4,
  },
})

export const ActiveHeaderIconButton = styled(HeaderIconButton)<{
  active?: boolean
}>(({ active = false }) => ({
  backgroundColor: active ? colorPalette.skyBlue[7] : colorPalette.monotone[0],
  transition: 'background-color 0.2s ease-in-out',
}))
